import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { UserAssignedBuildingsForm } from 'forms';

interface UserAssignedBuildingsDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  userId: number;
}

export const UserAssignedBuildingsDialog = ({
  visible = false,
  setVisible = () => {},
  userId,
}: UserAssignedBuildingsDialogProps) => {
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [, setLoadingSubmit] = useState<boolean>(false);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Building Assignments
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingY: 2 }}>
          <UserAssignedBuildingsForm
            userId={userId}
            onInit={(loading) => setLoadingForm(loading)}
            onSubmitting={(loading) => setLoadingSubmit(loading)}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton label="Confirm" onClick={() => onClose(null, 'anyway')} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form} />
    </Dialog>
  );
};
